import { Theme } from '@mui/material/styles'

export default function Progress(_: Theme) {
  return {
    MuiSkeleton: {},
    MuiLinearProgress: {},
  }
}
